import script from "./SalesDashReportGrid.vue?vue&type=script&setup=true&lang=js"
export * from "./SalesDashReportGrid.vue?vue&type=script&setup=true&lang=js"

import "./SalesDashReportGrid.vue?vue&type=style&index=0&id=0e602f30&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e602f30"]])

export default __exports__